export default __webpack_public_path__ + "static/media/IcSettings.679789b3.svg";